module.exports = __webpack_public_path__ + "static/media/voucher-icon.331f488f.svg";